"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
class Role {
    constructor(name) {
        this.name = '';
        this.name = name;
    }
    splitRole() {
        const sections = this.name.split(':');
        return sections;
    }
    parseRole() {
        const sections = this.splitRole();
        const action = sections[0];
        const targetId = sections[1];
        const subTargetId = sections[2];
        return {
            action,
            targetId,
            subTargetId,
        };
    }
    toString() {
        return this.name;
    }
    isEqual(otherRole) {
        if (this.name === otherRole.name) { // Roles are a true match
            return true;
        }
        const thisParsed = this.parseRole();
        const otherParsed = otherRole.parseRole();
        if (otherParsed.action === '*' && otherParsed.targetId === '*') {
            return true;
        }
        if (otherParsed.action === '*' && otherParsed.targetId === thisParsed.targetId) {
            return otherParsed.subTargetId === '*' || otherParsed.subTargetId === thisParsed.subTargetId;
        }
        if (otherParsed.action === thisParsed.action && otherParsed.targetId === '*') {
            return true;
        }
        if (otherParsed.action === thisParsed.action && otherParsed.targetId === thisParsed.targetId && otherParsed.subTargetId === '*') {
            return true;
        }
        return false;
    }
    isValid(tenantIdToRestrictTo) {
        const { action, targetId, subTargetId } = this.parseRole();
        if (!action || !targetId) {
            return false;
        }
        if (targetId === '*' && subTargetId) {
            return false;
        }
        if (tenantIdToRestrictTo && targetId !== tenantIdToRestrictTo) {
            return false;
        }
        return true;
    }
    static createRoleFromString(roleAsString) {
        const role = new Role(roleAsString);
        if (!role.isValid()) {
            throw new Error('Role is not valid, roles must have an action, type, and id, and be of the format a:t:i.');
        }
        return role;
    }
    static createRole(action, target) {
        let name = '';
        if (action) {
            name += `${action}`;
        }
        if (target.targetId) {
            name += `:${target.targetId}`;
        }
        if (target.subTargetId) {
            name += `:${target.subTargetId}`;
        }
        const role = new Role(name);
        if (!role.isValid()) {
            throw new Error('Role is not valid, roles must have an action, type, and id, and be of the format a:t:i.');
        }
        return role;
    }
    static validateUserPermissions(user, requiredRoles) {
        if (!user) {
            return false;
        }
        if (user.role === 'SuperAdmin') { // Allow use of old roles system
            return true;
        }
        const userRolesAsRoleObjects = user.roles.map((role) => new Role(role));
        for (const role of requiredRoles) {
            const matchingRoles = userRolesAsRoleObjects.filter((userRole) => role.isEqual(userRole));
            if (matchingRoles.length === 0) {
                return false;
            }
        }
        return true;
    }
}
exports.Role = Role;
//# sourceMappingURL=role.js.map